import { useState, useRef, useEffect } from 'react';
import styles from './TabBar.module.css';

function TabLabel({ label, onRename }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(label);
  const inputRef = useRef(null);

  useEffect(() => { setValue(label); }, [label]);
  useEffect(() => { if (editing) inputRef.current?.select(); }, [editing]);

  const commit = () => {
    const trimmed = value.trim() || label;
    if (trimmed !== label) onRename(trimmed);
    setEditing(false);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter')  { e.preventDefault(); commit(); }
    if (e.key === 'Escape') { setValue(label); setEditing(false); }
    e.stopPropagation();
  };

  if (editing) {
    return (
      <input
        ref={inputRef}
        className={styles.tabInput}
        value={value}
        onChange={e => setValue(e.target.value)}
        onBlur={commit}
        onKeyDown={onKeyDown}
        size={Math.max(value.length + 1, 6)}
        onClick={e => e.stopPropagation()}
      />
    );
  }

  return (
    <span
      className={styles.tabLabel}
      onDoubleClick={e => { e.stopPropagation(); setEditing(true); }}
      title="Double-click to rename"
    >
      {label}
    </span>
  );
}

export default function TabBar({ tabs, activeTabId, onSwitch, onCreate, onRename, onDelete }) {
  const sorted = [...tabs].sort((a, b) => a.order - b.order);

  return (
    <div className={styles.tabBar}>
      {sorted.map((tab, i) => (
        <button
          key={tab.id}
          className={`${styles.tab} ${tab.id === activeTabId ? styles.tabActive : ''}`}
          onClick={() => onSwitch(tab.id)}
          title={i < 9 ? `Ctrl+${i + 1}` : undefined}
        >
          <TabLabel label={tab.label} onRename={(label) => onRename(tab.id, label)} />
          {tabs.length > 1 && (
            <span
              className={styles.tabClose}
              onClick={e => {
                e.stopPropagation();
                if (window.confirm(`Close tab "${tab.label}"?`)) onDelete(tab.id);
              }}
              title="Close tab (Alt+W when active)"
            >
              ×
            </span>
          )}
        </button>
      ))}
      <button
        className={styles.tabAdd}
        onClick={() => onCreate()}
        title="New tab (Alt+N)"
      >
        +
      </button>
    </div>
  );
}
